import { render, staticRenderFns } from "./TaskCode.vue?vue&type=template&id=0972cf89&scoped=true"
import script from "./TaskCode.vue?vue&type=script&lang=js"
export * from "./TaskCode.vue?vue&type=script&lang=js"
import style0 from "./TaskCode.vue?vue&type=style&index=0&id=0972cf89&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0972cf89",
  null
  
)

export default component.exports